// Module
var code = "<div id=\"template-dialog-confirm\"> <p>{{templateUser}}</p> </div>";
// Exports
module.exports = code;